import React from "react";
import { IPolicyItem } from "./PolicyMenu";
import { ClickableDiv } from "../../../components/ClickableDiv";
import { useWindowBreakpoints } from "../../../custom-hooks/useWindowBreakpoints";
import { useHistory } from "react-router-dom";
import { useProdesegDropdownContext } from "../../../components/prodeseg-dropdown/ProdesegDropdownContextProvider";

export interface PolicyMenuItemProps {
    isSmall?: boolean;
    itemHeight?: "100" | "auto";
    policy: IPolicyItem;
    iconTheme?: "ligth" | "dark";
}

export const PolicyMenuItem: React.FC<PolicyMenuItemProps> = ({
    itemHeight = "100",
    isSmall = false,
    policy,
    iconTheme = "ligth",
}) => {
    const { isDownSm, isDownMd } = useWindowBreakpoints();
    const { setFalse } = useProdesegDropdownContext();
    const history = useHistory();

    const isLight = iconTheme === "ligth";
    const isDisabled = !!policy.isDisabled;

    const onClickItem = () => {
        if (isDisabled) return;
        if (policy.href && !policy.to) {
            window.open(policy.href, policy.hrefSamePage ? "_self" : "_blank");
            if (isDownSm && !isDisabled) setFalse();
            return;
        }
        if (policy.to && !policy.href) {
            history.push(policy.to);
            if (isDownSm && !isDisabled) setFalse();
        }
    };

    const getIconSize = () => {
        if (isDownSm) return `svg-${isSmall ? "s" : "m"}`;
        if (isDownMd) return `svg-${isSmall ? "m" : "l"}`;
        return `svg-${isSmall ? "l" : "xl"}`;
    };

    return (
        <>
            <ClickableDiv
                cursor
                className={`menu__item h-${itemHeight} ${isDisabled ? "menu__item--disabled" : ""} px-1 pt-2-1 pb-2 text-center transition-3s-ease`}
                onClick={() => {
                    if (!isDisabled) {
                        policy.onClick?.();
                        onClickItem();
                    }
                }}
                data-disabled={isDisabled}
                id={policy.id}
            >
                <div className={"fw-medium text-neutral-900 d-inline-block w-100 h-100"}>
                    <p
                        className={`menu__item__icon ${iconTheme} ${isLight ? "bg-white" : "bg-primary-900"} p-1 mx-auto mb-1 
                rounded-circle shadow-sm transition-3s-ease`}
                    >
                        {React.createElement(policy.icon, {
                            className: getIconSize(),
                        })}
                    </p>
                    <p className={`m-0 fw-medium ${isSmall ? "small" : ""}`}>{policy.title}</p>
                </div>
            </ClickableDiv>
            {policy.component}
        </>
    );
};
